import { Skeleton, useTheme } from "@mui/material"

export const CustomSkeleton = ({ variant, component, width, height, backgroundColor = 'grey.800' }) => {
   const theme = useTheme()
   return (
      <Skeleton variant={variant} animation="wave" sx={{ width, height, ...theme.typography[component] }} />
   )
}